import React from "react";
import { Helmet } from "react-helmet";
import { moment } from "../../common/common";
import cookie from "react-cookies";
import queryString from "query-string";
import { connect } from "react-redux";



import { setFilter, searchCSList, searchCSListMore } from "../../../actions/csFindingAct";
import { getLoggedProfile } from "../../../actions/sessionAct";
import { init, getFilterConfig, getVehicleType, getVehicleMake } from "../../../model/car";
import { searchInHouse } from "../../../model/common";
import { mapSdk } from "../../../model/base";

import { commonErr } from "../../common/errors";
import { LoadingInlineTime } from "../../common/loading";
import { MessageBox, MessageLine, Empty } from "../../common/messagebox";

import { formatTitleInUrl, stypes, wdType, viewModes } from "../../common/common";

import Header from "../../components/header";
import Login from "../../login/login";
import CSListView from "./components/cslistview";
import CSQuicklySearch from "./components/csquicklysearch";
import CSQuicklyFilter from "./components/csquicklyfilter";
import CSSearchFilter from "./components/cssearchfilter";
import CSSearchTime from "./cssearchscreen";
import CSFilterScreen from "./csfilterscreen";
import CSDetailPopup from "../detail/csdetailpopup"
import PriceTableBox from "./components/cspricetbox"
import { OptionalTime } from "../components/optionaltime";


import empty from "../../../static/images/empty/empty-mycar.svg";

const defPriceRange = {
	min: 500,
	max: 10000,
	step: 100,
};

const defLimitKMRange = {
	min: 0,
	max: 550,
	step: 50,
};

const defLimitKMPriceRange = {
	min: 0,
	max: 10,
	step: 5,
};

const defDPriceRange = {
	min: 0,
	max: 50,
	step: 5,
};

const defFuelCRange = {
	min: 0,
	max: 30,
	step: 5,
};

const defYearRange = {
	min: 2000,
	max: moment().year().valueOf(),
	step: 5,
};

const defSeatRange = {
	min: 2,
	max: 16,
	step: 2,
};

const defRadiusRange = {
	min: 5,
	max: 50,
	step: 3,
};




class CSFinding extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			errMsgBox: "",

			viewMode: viewModes.LIST,
			isOpenFilterBox: false,
			isOpenFilter: false,
			showAdvance: false,
			isShowPopup: false,
			isShowPriceTable: false,
			popupCarId: "",
			isOpenSearching: false,
			showSearchTime: true,
			showLoginForm: false,

			location: props.location,
			oriUrl: window.location.href,
			visible: true,
			visibleBottom: true,
			fixHeight: false,
			isOptionalTime: false,
			isSelectTimeCS: false,
			isOpenSearching: false,
			oriUrl: window.location.href,
		};
		this.stype = stypes.CS;
		this.isSD = false;
		this.prevScrollPos = window.scrollY;
		this.visible = true;
		this.visibleBottom = true;
		this.timeoutScroll = null;

		this.wrapperRef = React.createRef();
		this.wrapperMRef = React.createRef();
		this.map = React.createRef();
	}

	componentDidMount() {
		var startDate;
		var endDate;
		var startTime;
		var endTime;
		var lat = this.props.csFinding.filter.lat;
		var lng = this.props.csFinding.filter.lng;
		var address = this.props.csFinding.filter.address;
		var isAirDelivery = false;
		var deliveryId;
		var vehicleType;
		var vehicleMake;
		let timeCS;

		//overide filter by query params
		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);

			if (query.startDate) {
				startDate = moment(query.startDate * 1);
				// startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}
			if (query.endDate) {
				endDate = moment(query.endDate * 1);
				// endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}

			if (query.timeCS) {
				timeCS = query.timeCS * 1;
			}

			if (query.loc) {
				let buff = new Buffer(query.loc, "base64");
				const locStr = buff.toString("ascii");
				const locArray = locStr.split("-");
				lat = locArray[0] * 1;
				lng = locArray[1] * 1;
			}

			if (query.address) {
				address = query.address;
			}

			if (query.isAirDelivery) {
				isAirDelivery = query.isAirDelivery;
			}

			if (query.deliveryId) {
				deliveryId = query.deliveryId;
			}

			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_campaign) {
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/" });
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_medium) {
				cookie.save("_utm_medium", query.utm_medium, { path: "/" });
				cookie.save("_utm_medium", query.utm_medium, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_term) {
				cookie.save("_utm_term", query.utm_term, { path: "/" });
				cookie.save("_utm_term", query.utm_term, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_ext) {
				cookie.save("_utm_ext", query.utm_ext, { path: "/" });
				cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
			} else {
				cookie.remove("_utm_ext", { path: "/" });
				cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
			}
		} else {
			//use cookies for missing params
			if (!address) {
				const cAddress = cookie.load("_maddrcs");
				if (cAddress) {
					address = cAddress;
				}
			}

			// check valid cookie before set
			if (
				cookie.load("_mstartcs") < moment().add(2, "hours").valueOf() ||
				cookie.load("_mendcs") < moment().add(2, "hours").valueOf()
			) {
				cookie.remove("_mstartcs", { path: "/" });
				cookie.remove("_mendcs", { path: "/" });
			}

			const cStartCs = cookie.load("_mstartcs");

			if (cStartCs) {
				const cStartDate = moment(cStartCs * 1);
				startDate = cStartDate;
				startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}

			const cEndCs = cookie.load("_mendcs");

			if (cEndCs) {
				endDate = moment(cEndCs * 1);
				endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}
		}

		this.setState({
			isAirDelivery: isAirDelivery,
		});


	

		if (address && address !== "") {
			if (lat && lng) {
				if (startDate && endDate) {
					const filter = {
						...this.props.csFinding.filter,
						address: address,
						lat: lat,
						lng: lng,
						startDate: startDate,
						endDate: endDate,
						deliveryId: deliveryId,
						// directDelivery: isAirDelivery ? true : false,
						vehicleType: vehicleType ? vehicleType : undefined,
						vehicleMake: vehicleMake ? vehicleMake : 0,
						timeCS: timeCS,
					};

					this.setState({
						baseFilter: { ...filter },
					});

					this.setFilter(filter);
					this.searchCar(filter);
				} else {
					const filter  = {
						...this.props.csFinding.filter,
						address: address,
						lat: lat,
						lng: lng,
					};
				
					this.setFilter(filter);
					this.searchCar(filter);
				}
		
			} 
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Địa chỉ tìm kiếm không hợp lệ.",
			});
		}

		getFilterConfig().then((resp) => {
			if (resp.data.data) {
				this.setState({
					customFilterConfig: resp.data.data,
				});
			}
		});

		getVehicleType().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleTypes: resp.data.data.vehicleTypes,
				});
			}
		});

		getVehicleMake().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleMakes: resp.data.data.vehicleMakes,
				});
			}
		});

		document.addEventListener("click", this.handleClick);
		window.addEventListener("scroll", this.handleScroll);

		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
	
		window.gtag("event", "CS_FINDING", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		window.fbq("track", "CS_FINDING");
	}

	UNSAFE_componentWillUnmount() {
		// important
		window.removeEventListener("scroll", this.handleScroll);
	}
	
	//common
	handleClick = (event) => {
		const { target } = event;
		if (window.innerWidth > 991) {
			if (target !== null && this.wrapperRef.current !== null && !this.wrapperRef.current.contains(target)) {
				const { isSelectTimeCS } = this.state;
				if (isSelectTimeCS) {
					this.setState({
						isSelectTimeCS: false,
					});
				}
				
			}
		}

		if (window.innerWidth <= 991) {
			if (target !== null && this.wrapperMRef.current !== null && !this.wrapperMRef.current.contains(target)) {
				const { isSelectTimeCS } = this.state;
				if (isSelectTimeCS) {
					this.setState({
						isSelectTimeCS: false,
					});
				}
				
			}
		}
	};

	handleScroll = () => {
		const currentScrollPos = window.scrollY;
		this.visible = currentScrollPos < 89; //Height of Header
		this.visibleBottom = currentScrollPos < 89 || this.prevScrollPos > currentScrollPos;

		// Header and filter
		if (this.visible !== this.state.visible && this.state.viewMode === viewModes.LIST) {
			this.setState({
				visible: this.visible,
			});
		}

		//Show map button
		if (this.visibleBottom !== this.state.visibleBottom && this.state.viewMode === viewModes.LIST) {
			this.setState({
				visibleBottom: this.visibleBottom,
			});
		}

		this.prevScrollPos = currentScrollPos;
	};

	searchCar = (filter) => {
		// save search params cookies

		cookie.save("_maddr", filter.address, { path: "/" });
		cookie.save("_mstartcs", filter.startDate.valueOf(), { path: "/" });
		cookie.save("_mendcs", filter.endDate.valueOf(), { path: "/" });
		// cookie.save("_mtimecs", filter.timeCS, { path: "/" });

		this.searchCarList(filter);
	};

	searchCarList = (f) => {
		this.props.dispatch(searchCSList(f));
	};

	searchCarListMore = (f) => {
		this.props.dispatch(searchCSListMore(f));
	};

	toggleFilter = () => {
		this.setState({
			isOpenFilter: !this.state.isOpenFilter,
		});
	};

	hideFilter = () => {
		this.setState({
			isOpenFilter: false,
		});
	};

	setFilter = (filter) => {
		this.props.dispatch(setFilter(filter));
	};

	resetFilter = () => {
		let filter;

		const { startDate, endDate, address, lat, lng } = this.props.csFinding.filter;
		filter = {
			startDate: startDate,
			endDate: endDate,
			address: address,
			lat: lat,
			lng: lng,
			pos: 0,
			timeCS: 6,
			transmission: 0,
			sort: "pl",
			fuel: 0,
			vehicleType: [],
			vehicleMake: 0,
			vehicleModel: [],
		};

		this.setFilter(filter);
		this.searchCar(filter);
	};

	hasFilter = (filter, customFilterConfig) => {
		if (filter === undefined || customFilterConfig === undefined) {
			return false;
		}
		const sortValue = customFilterConfig && customFilterConfig.sort ? customFilterConfig.sort : "pl";

		return (
			(filter.vehicleType && filter.vehicleType.length > 0) ||
			filter.vehicleMake != "0" ||
			filter.vehicleModel.length > 0 ||
			filter.transmission != "0" ||
			filter.fuel != "0" ||
			filter.sort != "pl" ||
			filter.discount === true
		);
	};

	onSelectTimeCSChange = (e) => {
		let { endDatecs, startDatecs } = this.state;
		const time = e.target.value;

		if (time > 0) {
			endDatecs = moment(startDatecs).add(time, "months");
			const filter = {
				...this.props.csFinding.filter,
				timeCS: time,
				endDatecs,
			};

			this.setFilter(filter);
			this.searchCar(filter);
		} else {
			this.showOptionalTime();
			const filter = {
				...this.props.csFinding.filter,
				timeCS: time,
			};
			this.setFilter(filter);
		}
	};

	toggleSearching = () => {
		// if (this.state.isOpenSearching) {
		// 	if (this.props.csFinding.filter.address == "") {
		// 		const filter = {
		// 			...this.props.carFinding.filter,
		// 			address: this.state.addressBanner,
		// 			isOpenSearching: false,
		// 		};
		// 		this.setFilter(filter);
		// 	}
		// }

		const filter = {
			...this.props.csFinding.filter,
			isOpenSearching: !this.state.isOpenSearching,
		};
		this.setFilter(filter);

		this.setState(
			{
				isOpenSearching: !this.state.isOpenSearching,
			},
			() => {
				this.checkOpenSearchBox();
			}
		);
	};

	checkOpenSearchBox = () => {
		const filter = {
			...this.props.csFinding.filter,
			isOpenSearching: this.state.isOpenSearching,
		};
		this.setFilter(filter);
	};

	hideSearching = () => {
		this.setState({
			isOpenSearching: false,
		});
	};


	showOptionalTime = () => {
		this.setState({
			isOptionalTime: true,
		});
	};

	hideOptionalTime = () => {
		this.setState({
			isOptionalTime: false,
		});
	};

	toggleSelectTimeCS = () => {
		const { isSelectTimeCS } = this.state;
	
		this.setState({
			isSelectTimeCS: !isSelectTimeCS,
		});
	};

	togglePopup = (car) => {
		
		if (!this.state.isShowPopup) {
			window.history.pushState("", "", `/carsubscription/${formatTitleInUrl(car.name)}/${car.skuGroupId}`);
		} else {
			window.history.pushState("", "", this.state.oriUrl);
		}
		this.setState({
			isShowPopup: !this.state.isShowPopup,
			popupModelId: car.skuGroupId,
		});
		
	};

	togglePriceTable = (car) => {
		
		if (!this.state.isShowPopup) {
			window.history.pushState("", "", `/carsubscription/${formatTitleInUrl(car.name)}/${car.skuGroupId}`);
		} else {
			window.history.pushState("", "", this.state.oriUrl);
		}
		this.setState({
			isShowPriceTable: !this.state.isShowPriceTable,
			popupModelId: car.skuGroupId,
		});
		
	};

	onHidePopup = () => {
	
		window.history.pushState("", "", this.state.oriUrl);

		this.setState({
			isShowPopup: false,
		});
	};

	onHidePriceTable = () => {
	
		window.history.pushState("", "", this.state.oriUrl);

		this.setState({
			isShowPriceTable: false,
		});
	};


	render() {
		const { viewMode, isShowPopup, vehicleTypes, vehicleMakes, customFilterConfig, isSelectTimeCS, isOpenSearching, isOpenFilter, popupModelId } = this.state;

		return (
			<>
				<Header fixed={viewMode === viewModes.LIST ? true : false} visible={this.visible} />
				<CSQuicklySearch 
					visible={this.visible} 
					viewMode={viewMode} 
					isSelectTimeCS={isSelectTimeCS} 
					wrapperCSSelect={this.wrapperRef}
					toggleSelectTimeCS={this.toggleSelectTimeCS} 
					onSelectTimeCSChange={this.onSelectTimeCSChange} />
				<CSQuicklyFilter
					visible={this.visible}
					viewMode={viewMode}
					filter={this.props.csFinding.filter}
					vehicleTypes={vehicleTypes}
					vehicleMakes={vehicleMakes}
					counters={this.props.csFinding.counters}
					setFilter={this.setFilter}
					resetFilter={this.resetFilter}
					searchCar={this.searchCar}
					customFilterConfig={customFilterConfig}
					hasFilter={this.hasFilter}
				/>
				
				<CSListView togglePopup={this.togglePopup} togglePriceTable={this.togglePriceTable} searchCar={this.searchCar} searchCarListMore={this.searchCarListMore} />
				<CSSearchFilter
					visible={this.visible}
					toggleFilter={this.toggleFilter}
					toggleSearching={this.toggleSearching}
					resetFilter={this.resetFilter}
					filter={this.props.csFinding.filter}
					hasFilter={this.hasFilter}
					isSelectTimeCS={isSelectTimeCS} 
		
					toggleSelectTimeCS={this.toggleSelectTimeCS} 
					onSelectTimeCSChange={this.onSelectTimeCSChange} 
				/>
				<CSSearchTime
					isShow={isOpenSearching}
					hide={this.hideSearching}
					isSelectTimeCS={isSelectTimeCS} 
					wrapperRef={this.wrapperMRef}
					toggleSelectTimeCS={this.toggleSelectTimeCS} 
					onSelectTimeCSChange={this.onSelectTimeCSChange}
				/>
					<CSFilterScreen
						isShow={isOpenFilter}
						hide={this.hideFilter}
						defPriceRange={defPriceRange}
						defLimitKMRange={defLimitKMRange}
						defLimitKMPriceRange={defLimitKMPriceRange}
						defYearRange={defYearRange}
						defSeatRange={defSeatRange}
						defRadiusRange={defRadiusRange}
						defFuelCRange={defFuelCRange}
						defDPriceRange={defDPriceRange}
						filter={this.props.csFinding.filter}
						counters={this.props.csFinding.counters}
						totalCar={this.props.csFinding.total}
						customFilterConfig={customFilterConfig}
						setFilter={this.setFilter}
						resetFilter={this.resetFilter}
						searchCar={this.searchCar}
					/>
					{isShowPopup ? (
						<CSDetailPopup
							show={isShowPopup}
							onHide={this.onHidePopup}
							togglePopup={this.togglePopup}
							skuGroupId={popupModelId}
						/>
					) : null}
					{this.state.isShowPriceTable ? (
						<PriceTableBox show={this.state.isShowPriceTable} hideModal={this.onHidePriceTable} skuGroupId={popupModelId} />
					) : null}
			</>
		);
	}
}

function mapState(state) {
	return {
		appInit: state.appInit,
		csFinding: state.csFinding,
		session: state.session,
	};
}

export default connect(mapState)(CSFinding);
